import { KTSVG } from '../../../helpers'

function GetSupportedVersion({ data }: { data: any }) {
  return (
    <div className='modal fade' tabIndex={-1} id='get_supported_version'>
      <div className='modal-dialog modal-lg'>
        <div className='modal-content'>
          <div className='modal-header bg-success'>
            <h5 className='modal-title text-white'>Get Supported Version</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-success ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            {/* Versions Table */}
            {data?.data && (
              <div className='mb-4'>
                <h6 className='fw-bold'>Supported Versions</h6>
                <table className='table table-bordered table-sm'>
                  <thead className='table-light'>
                    <tr>
                      <th>Version</th>
                      <th>URL</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.data.map((item: any, index: number) => (
                      <tr key={index}>
                        <td>{item.version}</td>
                        <td>
                          <a href={item.url} target='_blank' rel='noreferrer'>
                            {item.url}
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* Meta Info */}
            <div>
              <h6 className='fw-bold'>Response Info</h6>
              <table className='table table-bordered table-sm'>
                <tbody>
                  <tr>
                    <td>Status Code</td>
                    <td>{data?.status_code}</td>
                  </tr>
                  <tr>
                    <td>Status Message</td>
                    <td>{data?.status_message}</td>
                  </tr>
                  <tr>
                    <td>Timestamp</td>
                    <td>{data?.timestamp}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GetSupportedVersion
